import { UserRole } from '../enums';

const BASE_SUPER_ADMINS = [UserRole.SUPER_ADMIN];
const BASE_ADMINS = [...BASE_SUPER_ADMINS, UserRole.ADMIN];
const BASE_ALL_ADMINS = [
  ...BASE_ADMINS,
  UserRole.PRINCIPAL,
  UserRole.SENIOR_PRINCIPAL,
  UserRole.VICE_PRINCIPAL,
  UserRole.HEAD_OF_SCHOOL,
  UserRole.DEPUTY_HEAD_OF_SCHOOL,
  UserRole.SCHOOL_OFFICE
];

export const RoleGroups = {
  SUPER_ADMINS: BASE_SUPER_ADMINS,
  ADMINS: BASE_ADMINS,
  ALL_ADMINS: BASE_ALL_ADMINS,
  TEACHING_STAFF: [
    ...BASE_ALL_ADMINS,
    UserRole.TEACHER,
    UserRole.COORDINATOR,
    UserRole.SECTION_CHIEF
  ],
  SUPPORT_STAFF: [
    ...BASE_ALL_ADMINS,
    UserRole.NURSE,
    UserRole.COUNSELLOR,
    UserRole.MODERATOR
  ]
};

export const hasRoleAccess = (
  userRole: string,
  allowedRoles: UserRole[]
): boolean => {
  if (!userRole || !allowedRoles || allowedRoles.length === 0) {
    return false;
  }

  return allowedRoles.includes(userRole as UserRole);
};

export const canAccessField = (
  userRole: string,
  allowedRoles?: UserRole[]
): boolean => {
  if (!userRole) return false;

  if (userRole === UserRole.SUPER_ADMIN) return true;

  if (allowedRoles && allowedRoles.length > 0) {
    return hasRoleAccess(userRole, allowedRoles);
  }

  return false;
};
